var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesTool(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_13728)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9983 23.1429C18.1524 23.1429 23.1412 18.1541 23.1412 12C23.1412 5.84601 18.1524 0.857178 11.9983 0.857178C5.8443 0.857178 0.855469 5.84601 0.855469 12C0.855469 18.1541 5.8443 23.1429 11.9983 23.1429Z",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63016 22.8918V17.8647C8.56169 17.4673 7.61482 16.7959 6.88562 15.9161C6.10718 14.977 5.60806 13.8381 5.4451 12.6292C5.28216 11.4203 5.4619 10.19 5.9639 9.07824C6.46588 7.96649 7.26993 7.01802 8.28451 6.34081C8.45272 6.2505 8.6387 6.19827 8.82931 6.1878C9.01992 6.17732 9.21052 6.20886 9.3876 6.2802V11.067C9.3876 12.0138 10.1551 12.7813 11.1019 12.7813H12.8615C13.8082 12.7813 14.5757 12.0138 14.5757 11.067L14.5757 6.13474C14.7534 6.09217 14.938 6.08744 15.1176 6.12085C15.2972 6.15426 15.4678 6.22508 15.6182 6.32869C16.6186 7.00604 17.4116 7.9476 17.9089 9.04868C18.4062 10.1497 18.5883 11.3672 18.435 12.5656C18.2818 13.764 17.7992 14.8964 17.0408 15.8369C16.355 16.6875 15.4679 17.3509 14.4623 17.7687L14.3911 22.874",
    stroke: "#0B1D2E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_13728"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTool);
export default __webpack_public_path__ + "static/media/features_tool.418eddb862ee14357a8449daf0c058dc.svg";
export { ForwardRef as ReactComponent };